import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Formations } from './pages/Formations';
import { FormationDetail } from './pages/FormationDetail';
import { NotreApproche } from './pages/NotreApproche';
import { Qualiopi } from './pages/Qualiopi';
import { Contact } from './pages/Contact';
import { Accessibilite } from './pages/Accessibilite';
import { MentionsLegales } from './pages/MentionsLegales';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31c1l6kv02akh">
      <ScrollToTop data-id="element-1" data-mp="2wk0a329kipw1" />
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-2" data-mp="2wjgrrkg09zhh">
        <a href="#contenu" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-brand-900 focus:px-4 focus:py-2 focus:text-white" data-id="element-3" data-mp="2wi5nzkmk8rqd">
          Aller au contenu
        </a>
        <Header data-id="element-4" data-mp="3ij668fcdfvai" />
        <main id="contenu" className="flex-1" data-id="element-5" data-mp="3ijpd910hgz9r">
          <Routes data-id="element-6" data-mp="3ml13n8r6loj0">
            <Route path="/" element={<Home data-id="element-8" data-mp="3mjzpgvevclx2" />} data-id="element-7" data-mp="3mkhn9wh6j873" />
            <Route path="/formations" element={<Formations data-id="element-10" data-mp="3rbrcwx2qabiz" />} data-id="element-9" data-mp="3mj6jvxrnc2gi" />
            <Route path="/formations/:slug" element={<FormationDetail data-id="element-12" data-mp="5yjsutqtdfe" />} data-id="element-11" data-mp="3rcsxpt9jqcdw" />
            <Route path="/notre-approche" element={<NotreApproche data-id="element-14" data-mp="56l3b4umzkw" />} data-id="element-13" data-mp="680frswe88f" />
            <Route path="/qualiopi" element={<Qualiopi data-id="element-16" data-mp="2zm4zaoz9bl3x" />} data-id="element-15" data-mp="2zld1d7i6tbah" />
            <Route path="/contact" element={<Contact data-id="element-18" data-mp="33mow1rfx4mpj" />} data-id="element-17" data-mp="2zmwj72jhrued" />
            <Route path="/accessibilite" element={<Accessibilite data-id="element-20" data-mp="33mym1f0yqtv8" />} data-id="element-19" data-mp="33lwyib2rgewm" />
            <Route path="/mentions-legales" element={<MentionsLegales data-id="element-22" data-mp="38kqbm2e4y3w9" />} data-id="element-21" data-mp="38lrq6gud18iq" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-24" data-mp="3dkuw03i5zirr" />} data-id="element-23" data-mp="38nup5qdhqbzl" />
          </Routes>
        </main>
        <Footer data-id="element-25" data-mp="3diruam7ng177" />
      </div>
    </BrowserRouter>;
}